import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Logo from '../images/navlogo.jpg';

const AdminNavbar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    navigate('/login');
  };

  return (
         
          <nav className="bg-white shadow-md">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
              <div className="flex items-center">
                <img src={Logo} alt="Logo" className="h-12 w-auto object-contain" />
                <span className="ml-3 text-xl md:text-2xl font-bold text-blue-800">Admin Dashboard</span>
              </div>
              <div className="hidden md:flex items-center space-x-4">
                <Link to="/" className="bg-gray-200 text-gray-900 font-semibold px-6 py-2 rounded-md text-sm hover:shadow-md hover:scale-105 active:scale-95">
                  Back to Website
                </Link>
                <Link to="/admin-dashboard/profile" className="bg-gray-200 text-gray-900 font-semibold px-6 py-2 rounded-md text-sm hover:shadow-md hover:scale-105 active:scale-95">
                  Profile
                </Link>
                <button 
                  onClick={handleLogout}
                  className="bg-yellow-300 text-gray-900 font-semibold px-6 py-2 rounded-md text-sm hover:shadow-md hover:scale-105 active:scale-95"
                >
                  Logout
                </button>
              </div>
              <div className="md:hidden">
                <button className="text-gray-800 focus:outline-none">
                  <svg
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </nav>
  )}

  export default AdminNavbar;